import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  Home,
  HeartPulse,
  Info,
  CalendarDays,
  BookOpen,
  MessageCircle,
} from 'lucide-react';
import './MobileBottomNav.css';

interface NavItem {
  label: string;
  path: string;
  icon: React.ComponentType<{ className?: string; size?: number | string }>;
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  {
    label: 'Home',
    path: '/',
    icon: Home,
    end: true,
  },
  {
    label: 'Services',
    path: '/services',
    icon: HeartPulse,
  },
  {
    label: 'About',
    path: '/about',
    icon: Info,
  },
  {
    label: 'Classes',
    path: '/classes',
    icon: CalendarDays,
  },
  {
    label: 'Blog',
    path: '/blog',
    icon: BookOpen,
  },
  {
    label: 'Contact',
    path: '/contact',
    icon: MessageCircle,
  },
];

const ALLOWED_NAV_PATHS = new Set([
  '/',
  '/services',
  '/about',
  '/classes',
  '/blog',
  '/contact',
]);

export const MobileBottomNav: React.FC = () => {
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 768;
  });

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const normalizedPath = location.pathname.toLowerCase().replace(/\/+$/, '') || '/';
  const isAllowedPage = ALLOWED_NAV_PATHS.has(normalizedPath);

  if (!isMobile || !isAllowedPage) {
    return null;
  }

  return (
    <>
      <nav
        className="mobile-bottom-nav-container"
        aria-label="Mobile Navigation"
      >
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `mobile-bottom-nav-item ${isActive ? 'active' : ''}`
              }
              aria-label={item.label}
            >
              <Icon className="mobile-bottom-nav-icon" size={20} />
              <span className="mobile-bottom-nav-label">{item.label}</span>
            </NavLink>
          );
        })}
      </nav>
      {/* Spacer to prevent content or footer from being obscured */}
      <div className="mobile-bottom-nav-spacer" aria-hidden="true" />
    </>
  );
};

export default MobileBottomNav;
